import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-quote',
  templateUrl: './quote.component.html',
  styleUrls: ['./quote.component.css']
})
export class QuoteComponent implements OnInit {

  frozenProduct:Boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  toggleFrozenProduct(value:Boolean):void {
    this.frozenProduct = value;
  }

}
